import classNames from 'classnames'

import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

import stylesTable from '../Table.module.scss'

import { IScrollButton } from './models/IRecalculatingScroll'

import styles from './TableHeader.module.scss'

interface ITableHeaderProps {
  onScrollButtonClickCallback: (direction: 'previous' | 'next') => void
  scrollButtons: IScrollButton
}

export const TableHeader = ({ onScrollButtonClickCallback, scrollButtons }: ITableHeaderProps) => {
  return (
    <div className={styles.root}>
      {scrollButtons.previous !== 'hidden' ? (
        <Tooltip
          className={classNames(
            styles.arrow,
            styles['arrow--prev'],
            scrollButtons.previous === 'disabled' ? styles.arrow_disabled : ''
          )}
          tipContent={() => <span>Scroll to previous columns</span>}
        >
          <button
            className={classNames(
              stylesTable.button,
              stylesTable['button--icon-btn'],
              styles.arrow__button
            )}
            disabled={scrollButtons.previous === 'disabled'}
            onClick={() => onScrollButtonClickCallback('previous')}
            type={'button'}
          >
            <i className={classNames(stylesTable.button__icon, 'kbase kbase-omni-arrows-left')} />
          </button>
        </Tooltip>
      ) : null}

      {scrollButtons.next !== 'hidden' ? (
        <Tooltip
          className={classNames(
            styles.arrow,
            styles['arrow--next'],
            scrollButtons.next === 'disabled' ? styles.arrow_disabled : ''
          )}
          horizontalDirection={TPopupHorizontal.Left}
          tipContent={() => <span>Scroll to next columns</span>}
        >
          <button
            className={classNames(
              stylesTable.button,
              stylesTable['button--icon-btn'],
              styles.arrow__button
            )}
            disabled={scrollButtons.next === 'disabled'}
            onClick={() => onScrollButtonClickCallback('next')}
            type={'button'}
          >
            <i className={classNames(stylesTable.button__icon, 'kbase kbase-omni-arrows-right')} />
          </button>
        </Tooltip>
      ) : null}
    </div>
  )
}
